import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Card, Tag, Typography } from "antd";
import { CloseCircleFilled } from "@ant-design/icons";
import moment from "moment";
import fertilityImage from "../../assets/images/auth/fertilityImage.svg";

const { Title, Text } = Typography;

const accentBtn = {
  height: "46px",
  borderRadius: "8px",
  fontWeight: 600,
  fontSize: "16px",
  color: "#ffffff",
  backgroundColor: "#00ADEF",
  border: "1px solid #00ADEF",
  padding: "0 32px",
};

const outlineBtn = {
  height: "46px",
  borderRadius: "8px",
  fontWeight: 600,
  fontSize: "16px",
  padding: "0 32px",
};

export default function PaymentCancel() {
  const navigate = useNavigate();
  const sessionId = new URLSearchParams(window.location.search).get("session_id");

  const booking = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("mfl_pending_booking") || "null");
    } catch {
      return null;
    }
  }, []);

  const whenLabel =
    booking?.date && booking?.startTime
      ? `${moment(booking.date).format("dddd, MMMM D, YYYY")} · ${booking.startTime}${booking.endTime ? ` – ${booking.endTime}` : ""}`
      : null;

  return (
    <div style={{ minHeight: "100vh", backgroundColor: "#ffffff", padding: "24px 16px" }}>
      <div style={{ maxWidth: 560, margin: "0 auto" }}>
        <nav style={{ display: "flex", alignItems: "center", marginBottom: 40 }}>
          <img src={fertilityImage} alt="myfertility" style={{ width: "140px" }} />
        </nav>

        <Card
          style={{
            backgroundColor: "#f5f5f5",
            borderRadius: 12,
            border: "none",
            textAlign: "center",
            padding: "8px 0",
          }}
        >
          <CloseCircleFilled style={{ fontSize: 56, color: "#ff4d4f", marginBottom: 16 }} />
          <Title level={2} style={{ marginBottom: 8 }}>
            Payment Cancelled
          </Title>
          <Text type="secondary" style={{ fontSize: 15 }}>
            Your booking was not completed. No charge was made.
          </Text>

          {booking && (
            <Card
              bordered
              style={{ marginTop: 28, textAlign: "left", backgroundColor: "#ffffff" }}
            >
              <Title level={5} style={{ marginBottom: 12 }}>
                Appointment that was not completed
              </Title>
              {booking.providerName && (
                <div style={{ marginBottom: 8 }}>
                  <Text strong>Clinician: </Text>
                  <Text>
                    {booking.providerName}
                    {booking.providerRole ? ` · ${booking.providerRole}` : ""}
                  </Text>
                </div>
              )}
              {whenLabel && (
                <div style={{ marginBottom: 8 }}>
                  <Text strong>When: </Text>
                  <Text>{whenLabel}</Text>
                </div>
              )}
              {booking.meetingType && (
                <div style={{ marginBottom: 8 }}>
                  <Text strong>Meeting: </Text>
                  <Text>{booking.meetingType}</Text>
                </div>
              )}
              <Tag color="red" style={{ marginTop: 8 }}>
                Not charged
              </Tag>
            </Card>
          )}

          {sessionId && (
            <div style={{ marginTop: 20 }}>
              <Text type="secondary" style={{ fontSize: 12 }}>
                Session reference: {sessionId}
              </Text>
            </div>
          )}

          <div
            style={{
              marginTop: 28,
              display: "flex",
              gap: 12,
              justifyContent: "center",
              flexWrap: "wrap",
            }}
          >
            <Button style={accentBtn} onClick={() => navigate(-1)}>
              Try Again
            </Button>
            <Button style={outlineBtn} onClick={() => navigate("/patient")}>
              Return to Dashboard
            </Button>
          </div>
        </Card>
      </div>
    </div>
  );
}
